// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"0aff56ee","887":"3c1092f5"}[chunkId] + ".chunk.css";
};